import { events } from '../../../services/api.admin';
import { fetchTableData, deleteTableData, refresh } from '../tables';
import { MODELS, ADDRESS_FIELDS } from '../../../constants/admin/settings';
import { fetchModel, submit, fetchDependencies } from '../forms';
import { submit as modalSubmit } from '../modal.forms';
import { pick } from 'lodash';
import { setTab } from '../tabs';
import { LINEUP_TAB } from '../../../constants/settings';
import { apiDataToState } from '../../../selectors/events/events';
import { TABLE_INDICES } from '../../../constants/admin/tables';
import { ADMIN_MODAL_FORMS } from '../../../constants/actions';

export function fetchEventsAsDependency(context) {
    return fetchDependencies([context ? () => events.getOrgAll(context) : events.getAll]);
}

export function fetchList(contextId, pagination) {
    return fetchTableData(
        contextId ? () => events.getOrg(contextId, pagination) : () => events.get(pagination),
        'events',
        {
            pagination
        }
    );
}

export function fetchEventSenders(id) {
    return fetchTableData(() => events.getSenders(id), 'senders', {
        tableIndex: TABLE_INDICES[MODELS.EVENT_EMAIL_SENDER]
    });
}

export function deleteEvents() {
    return deleteTableData(events.delete, MODELS.EVENT);
}

export function create(data) {
    return submit(() => events.create(_permitBody(data)), 'Event successfully created.');
}

export function update(data, id, _, onSuccess) {
    return submit(() => events.update(id, _permitBody(data)), 'Event successfully updated.', {
        beforeDone: (_response, _dispatch, _getState, doneFunction) => {
            onSuccess();
            doneFunction();
        }
    });
}

export function setDates(data) {
    return submit(() => events.update(data.id, _permitBody(data)), 'Event dates successfully set.', {
        afterDone: dispatch => {
            dispatch(setTab(LINEUP_TAB));
        }
    });
}

export function fetchMember(id) {
    return fetchModel(() => events.getMember(id), MODELS.EVENT, {
        transform: apiDataToState
    });
}

const _permitBody = (data, extraFields = []) =>
    pick(
        data,
        [
            'name',
            'organizationId',
            'chatEnabled',
            'timeZone',
            'defaultSigner',
            'defaultSignerFunction',
            'defaultSignature',
            'performanceSigner',
            'performanceSignerFunction',
            'performanceSignature',
            'allowPerformanceContracts',
            'start',
            'end'
        ]
            .concat(Object.keys(ADDRESS_FIELDS))
            .concat(extraFields)
    );

export function createSender(id, data) {
    return modalSubmit(() => events.senderPost(id, data), {
        beforeDone: dispatch => {
            dispatch({ type: ADMIN_MODAL_FORMS.SUCCESS });
            dispatch(refresh(TABLE_INDICES[MODELS.EVENT_EMAIL_SENDER]));
        }
    });
}



// WEBPACK FOOTER //
// ./src/actions/admin/models/events.js